import { compact, isArray } from 'lodash-es';

export class LayoutHelper {
    constructor(layout, fields) {
        this.layout = layout;
        this.fields = fields;
    }

    getFieldsStartingAt(name) {
        function mapItems([groupName, groupTitle, groupContent]) {
            if (Array.isArray(groupContent)) {
                return groupContent.flatMap(mapItems);
            }
            return [[groupContent, groupName, groupTitle]];
        }

        const objectLayout = Object.fromEntries(
            this.layout
                .flatMap(mapItems)
                .map(([groupContent, groupName, groupTitle]) => [
                    groupContent,
                    [groupName, groupTitle],
                ])
        );

        let state = 0;
        return Object.fromEntries(
            compact(
                this.fields.map((field) => {
                    // state 0: We have not found the field entry of this group yet.
                    // state 1: We are outputting all entry's we find.
                    // state 2: We found a field belonging to another group, stop outputting.
                    if (state === 1 && Object.keys(objectLayout).includes(field.name)) {
                        state = 2;
                    }
                    if (state === 2 || (state === 0 && field.name !== name)) {
                        return null;
                    }
                    if (state === 0) {
                        state = 1;
                    }
                    return [field.name, field];
                })
            )
        );
    }

    createTree() {
        const convertGroup = ([name, title, content]) => ({
            name,
            title,
            ...(isArray(content)
                ? { groups: content.map(convertGroup) }
                : { fields: this.getFieldsStartingAt(content) }),
        });

        const treeWithoutFields = this.layout.map((group) => convertGroup(group));

        const collectFieldsInGroupRecursive = (group) => {
            const fieldsInGroups = group.groups
                ? group.groups.map((childGroup) => collectFieldsInGroupRecursive(childGroup))
                : [];

            return Object.assign({}, group?.fields ?? {}, ...fieldsInGroups);
        };

        const addFieldsWhenMissing = (group) => ({
            ...group,
            ...(!group.fields ? { fields: collectFieldsInGroupRecursive(group) } : {}),
            ...(group.groups ? { groups: group.groups.map(addFieldsWhenMissing) } : {}),
        });

        return treeWithoutFields.map(addFieldsWhenMissing);
    }
}
